export default [
  {
    path: "/home",
    name: "csm-home",
    component: () => import("@/views/dashboard/Dashboard.vue"),
    meta: {
      resource: "Admin",
      action: "read",
    },
  },
];
